import React, { useState, useEffect } from 'react';

const InternetCheck = ({ children }) => {
    const [isOnline, setIsOnline] = useState(navigator.onLine);

    useEffect(() => {
        const handleOnline = () => setIsOnline(true);
        const handleOffline = () => setIsOnline(false);

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    if (!isOnline) {
        return (
            <div style={{
                height: '100vh', width: '100vw',
                display: 'flex', flexDirection: 'column',
                alignItems: 'center', justifyContent: 'center',
                backgroundColor: '#f3f4f6', color: '#1f2937',
                textAlign: 'center', padding: '20px', zIndex: 9999, position: 'fixed', top: 0, left: 0
            }}>
                <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>📡</div>
                <h1 style={{ marginBottom: '10px' }}>No Internet Connection</h1>
                <p style={{ color: '#6b7280', maxWidth: '400px', marginBottom: '20px' }}>
                    The Library System requires an active internet connection to ensure data integrity.
                </p>
                <button
                    onClick={() => window.location.reload()}
                    style={{
                        padding: '12px 24px',
                        background: '#4361ee', color: 'white',
                        border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '1rem'
                    }}
                >
                    Retry Connection
                </button>
            </div>
        );
    }

    return children;
};

export default InternetCheck;